import { useEffect, useState } from "react";
import api from "../api";

export default function Resultados() {
  const [rows,setRows]=useState([]);
  const [loading,setLoading]=useState(true);

  useEffect(()=>{
    (async ()=>{
      try{
        const correo=localStorage.getItem("email");
        const {data}=await api.get(`/mis-resultados/?correo=${correo}`);
        setRows(data);
      }catch(e){ console.error(e); }
      setLoading(false);
    })();
  },[]);

  if(loading)      return <p className="p-6">Cargando…</p>;
  if(!rows.length) return <p className="p-6">Aún no tienes resultados registrados.</p>;

  const dateFmt = iso => new Date(iso).toLocaleString("es-PE",{dateStyle:"short",timeStyle:"short"});

  return(
    <div className="max-w-3xl mx-auto p-6">
      <h1 className="text-2xl font-bold text-center mb-6">Mis resultados</h1>
      {rows.map(r=>(
        <div key={r.id} className="border rounded-xl shadow-sm p-5 mb-6 bg-white">
          <div className="flex justify-between items-center mb-4">
            <h2 className="font-semibold">
              {r.tipo} {r.numero}{" "}
              <span className="text-gray-500 text-sm font-normal">({dateFmt(r.fecha_realizacion)})</span>
            </h2>
            <p className="text-xl font-bold text-blue-600">{Number(r.nota).toFixed(2)}</p>
          </div>

          <div className="grid grid-cols-3 gap-4 text-center text-sm">
            <div><p className="text-2xl font-bold text-green-600">{r.preguntas_correctas}</p><p>Correctas</p></div>
            <div><p className="text-2xl font-bold text-red-600">{r.preguntas_incorrectas}</p><p>Incorrectas</p></div>
            <div><p className="text-2xl font-bold text-gray-700">{r.preguntas_sin_responder}</p><p>En blanco</p></div>
          </div>
        </div>
      ))}
    </div>
  );
}
